import * as React from "react";
/* eslint-disable import/no-webpack-loader-syntax */
import SpinnerIcon from "./Spinner.png";
/* eslint-enable import/no-webpack-loader-syntax */

const Spinner = () => {
  return <img alt="" src={SpinnerIcon} className="spinner" />;
};

export default Spinner;



// WEBPACK FOOTER //
// ./src/components/Spinner/index.tsx